import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './i18n';

import { FnolProvider } from './context';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback='Laddar'>
      <FnolProvider>
        <App />
      </FnolProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);
